import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';

const t = translate('basket');

const StyledServiceFeeIncludedText = styled(Text.SM)`
  display: flex;
  justify-content: flex-end;
`;

const ServiceFeeIncludedText = () => (
  <StyledServiceFeeIncludedText color={colors.ink50}>{t('.service_fee_included')}</StyledServiceFeeIncludedText>
);

export default ServiceFeeIncludedText;
